import type { SxProps, Theme } from '@mui/material/styles'

export const skeletonRoundedSx: SxProps<Theme> = {
  borderRadius: '12px',
}

export const skeletonBusyProps = {
  'aria-busy': true as const,
}
